export default {
    namespaced: true,
    state: {
        //大事件展示开关
        bigNews: true
    },
    mutations: {
        changeBigNews(state, value) {
            console.log('changeBigNews', value)
            state.bigNews = value
        }
    }
}